export const ASPECT_RATIOS = ['1:1', '2:3', '3:2', '9:16', '16:9']

export const VARIATION_COUNTS = [1, 2, 3, 4]
